module.exports = __webpack_public_path__ + "img/20191104162735360截图20191104152142339.6df03b77.jpg";